import type { SVGProps } from "react";
export interface MessageRobotIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function MessageRobotIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: MessageRobotIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M.875 15v-3.5a1.125 1.125 0 0 1 2.25 0V15a1.125 1.125 0 0 1-2.25 0m20 0v-3.5a1.126 1.126 0 0 1 2.25 0V15a1.125 1.125 0 0 1-2.25 0m-10-8.5V4.8a2.12 2.12 0 0 1-.99-1.583L9.875 3l.01-.218A2.126 2.126 0 0 1 12.001.875l.216.01A2.126 2.126 0 0 1 14.124 3c0 .76-.4 1.424-.998 1.8v1.7a1.125 1.125 0 0 1-2.25 0Z"
      />
      <path
        fill={color}
        d="M18.875 9.5c0-1.035-.84-1.875-1.875-1.875H7c-1.036 0-1.875.84-1.875 1.875v7.32c0 1.035.84 1.875 1.875 1.875h.5c.62 0 1.124.503 1.125 1.125v.978q.002.033.008.038a.1.1 0 0 0 .028.027.1.1 0 0 0 .038.013.1.1 0 0 0 .037-.012L11.79 19.2l.23-.118a4.1 4.1 0 0 1 1.745-.386H17c1.036 0 1.875-.84 1.875-1.875zm-5.389 5.153a1.126 1.126 0 0 1 1.607 1.572l-.299.305A4.12 4.12 0 0 1 12 17.62a4.11 4.11 0 0 1-2.793-1.091l-.299-.305-.072-.09a1.124 1.124 0 0 1 1.678-1.482l.08.082.136.14c.335.31.78.496 1.27.496a1.87 1.87 0 0 0 1.408-.636l.08-.082ZM15 10.63a.62.62 0 0 0-.124.37l.013.127q.03.136.111.245zm1.001.742a.6.6 0 0 0 .113-.245l.012-.126-.012-.126a.6.6 0 0 0-.113-.245zm-6.888-.497A.6.6 0 0 0 9 10.628v.744a.6.6 0 0 0 .112-.246L9.125 11zM8 10.628a.62.62 0 0 0-.125.372l.013.126a.6.6 0 0 0 .112.246zm2.124.372a1.624 1.624 0 0 1-3.241.167L6.875 11l.008-.166A1.625 1.625 0 0 1 8.5 9.375l.166.008c.82.083 1.458.775 1.458 1.617m7.001 0a1.625 1.625 0 0 1-3.242.167L13.875 11l.008-.166a1.625 1.625 0 0 1 1.618-1.459l.165.008c.82.083 1.459.776 1.459 1.617m4 5.82A4.125 4.125 0 0 1 17 20.945h-3.235c-.314 0-.623.078-.898.228L9.814 22.84c-1.521.83-3.367-.237-3.434-1.947a4.12 4.12 0 0 1-3.505-4.073V9.5A4.125 4.125 0 0 1 7 5.375h10A4.125 4.125 0 0 1 21.125 9.5z"
      />
    </svg>
  );
}
